module.exports = __webpack_public_path__ + "static/assets/905518b40052e100ff8f1e33970639dc.png";